import {Component, OnInit} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";
import {Order} from "../../../../../../common/interfaces/order.interface";


@Component({
    selector: "section-order-list-type-transfer",
    template: `
        <section-order-list [params]="params"></section-order-list>`
})
export class OrderListTypeTransferComponent implements Base.IComponent, OnInit {

    public readonly state: Base.IState;

    public params: Order.IOrderListParams;

    public constructor() {
    }

    public ngOnInit(): void {
        this.params = {
            title: "Warehouse transfer orders list",
            state: this.state,
            actions: {
                view: true,
                delete: true,
                add: false,
                export: true,
                remarks: true
            },
            query: {order_type: "transfer"}
        };
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "orders-type-transfer",
            actions: {
                "browse": ["browse_orders"]
            }
        };
    }

}
